import React, { useRef }           from "react"
import AssetSelect                 from "@shared/assetSelect"
import Input                       from "@shared/input"
import Combobox                    from "@shared/combobox"
import TextArea                    from "@shared/textarea"
import OverlaySpinner              from "@shared/overlaySpinner"
import { UploadFiles }             from "./uploadFiles"
import { Category }                from "./category"
import { ExtraFields }             from "./extraFields"
import { DefaultStorehouse }       from "./defaultStorehouse"
import { Partner }                 from "./partner"
import { Products }                from "./products"
import { Checkboxes }              from "./checkboxes"
import { Type }                    from "./type"
import { Materials }               from './materials'
import { ManagerSelect  }          from "../stepTwo/managerSelect"
import { TechnicianSelect }        from "../stepTwo/technicianSelect"
import { SecondaryTechnicians }    from "../stepTwo/secondaryTechnicians"
import { DatePlanned }             from "../stepTwo/datePlanned"

export const StepOne = ({
  categories,
  categoryRequired,
  priorities,
  titleFromCategory,
  categoryFields,
  checkboxes,
  workorderState,
  setWorkorderState,
  setCurrentStep,
  storehouses,
  blueprints,
  siteMaterials,
  changeAssets,
  displayUnpaid,
  includeMbcContracts,
  allowRecurrency,
  handleSubmit,
  managers,
  technicians,
  isSubmitting,
  changeTechnician,
  maximumDuration,
  maxSizeMb,
  partners
}) => {
  const formRef = useRef()

  const changeValue = (value, name) => {
    setWorkorderState({ [name]: value })
  }

  const goToStepTwo = () => {
    if(!formRef.current.reportValidity()) return
    setCurrentStep(2)
  }

  const title = () => {
    if (workorderState.purchaseOrderId) {
      return <h4>{ I18n.t("workorders.new_purchase_delivery") }</h4>
    } else if (workorderState.parentWorkorderId) {
      return <h4>{ I18n.t("workorders.new_passage") }</h4>
    } else  {
      return <h4>{ I18n.t("workorders.new_order") }</h4>
    }
  }

  return(
    <div className = "workorder-form workorder-form-react step-one">
      <div className = "card-body">
        { title() }
        <form ref = { formRef }>
          <AssetSelect
            type     = 'site'
            onChange = { changeAssets }
            options  = {
              {
                displayContact:     true,
                displayLink:        true,
                displayAddress:     true,
                displayHistory:     true,
                displayObservation: true,
                displayContact:     true,
                includeMbcContracts: includeMbcContracts,
                displayMaterials:   true,
                displayUnpaid:      displayUnpaid,
                disabled: {
                  mbc_contract: !!workorderState.mbcContractId
                },
                required: {
                  client:   true,
                  site:     true,
                  address:  true
                }
              }
            }
            data={
              {
                client:      workorderState.clientId,
                site:        workorderState.siteId,
                contact:     workorderState.contactId,
                mbcContract: workorderState.mbcContractId
              }
            }
          />

          <Partner
            partners          = { partners }
            workorderState    = { workorderState }
            setWorkorderState = { setWorkorderState }
          />

          <Type
            materials               = { siteMaterials }
            workorderState          = { workorderState }
            setWorkorderState       = { setWorkorderState }
          />

          <Category
            workorderState     = { workorderState }
            setWorkorderState  = { setWorkorderState }
            categories         = { categories }
            categoryRequired   = { categoryRequired }
            workorderCategory  = { workorderState.categoryId }
            categoryFields     = { categoryFields }
            />

          { siteMaterials.length > 0 &&
            <Materials
              materials         = { siteMaterials }
              workorderState    = { workorderState }
              setWorkorderState = { setWorkorderState }
              blueprints        = { blueprints }
              allowRecurrency   = { allowRecurrency }
              />
          }

          { !titleFromCategory &&
            <Input
              onChange     = { value => changeValue(value, 'title') }
              id           = "workorder_name"
              name         = "title"
              defaultValue = { workorderState.title || '' }
              placeholder  = { I18n.t("workorders.enter_title") }
              label        = { I18n.t("workorders.wo_title") }
            />
          }

          <div className="form-group">
            <label required={ !titleFromCategory }>
              {I18n.t("workorders.demand_description")}
            </label>

            <TextArea
              id           = "workorder_description"
              name         = "description"
              onChange     = {value => changeValue(value, 'description')}
              defaultValue = {workorderState.description || ''}
              placeholder  = {I18n.t("workorders.enter_description")}
              required     = { !titleFromCategory }
            />
          </div>

          <ExtraFields
            workorderState    = { workorderState }
            setWorkorderState = { setWorkorderState }
          />

          <div className= "d-flex gap-5">
            <ManagerSelect
              managers = { managers }
              manager  = { workorderState.managerId }
              onChange = { managerId => { setWorkorderState({ managerId: managerId }) } }
            />
            <TechnicianSelect
              technicians          = { technicians.filter(tech => !workorderState.secondaryTechniciansIds.includes(tech.id)) }
              workorderState       = { workorderState }
              onTechChange         = { changeTechnician }
              checkAvailability
            />
          </div>
          <SecondaryTechnicians
            technicians             = { technicians.filter(tech => tech.id !== workorderState.technicianId) }
            technicianId            = { workorderState.technicianId }
            secondaryTechniciansIds = { workorderState.secondaryTechniciansIds }
            onSelect                = { technicians => { setWorkorderState({ secondaryTechniciansIds: technicians.map(tech => tech.id) }) } }
          />
          <DatePlanned
            workorderState    = { workorderState }
            setWorkorderState = { setWorkorderState }
            maximumDuration   = { maximumDuration }
            autoNumbered      = { false }
          />
          <Products
            workorderState    = { workorderState }
            setWorkorderState = { setWorkorderState }
          />
          {
            storehouses &&
            <DefaultStorehouse
              storehouses       = { storehouses }
              workorderState    = { workorderState }
              setWorkorderState = { setWorkorderState }
            />
          }


          { !!priorities.priorities.length && workorderState.workorderType != 'Preventive' && !workorderState.parentWorkorderId &&
            <Combobox
              options         = { priorities.priorities }
              onSelectElement = { priority => changeValue(priority.id, 'workorderPriorityId') }
              placeholder     = { I18n.t("workorder_priorities.select_priority") }
              value           = { workorderState.workorderPriorityId || '' }
              label           = { I18n.t("workorder_priorities.workorder_priority") }
              className       = "form-group"
              required        = { priorities.mandatory }
            />
          }
          <Checkboxes
            checkboxes              = { checkboxes }
            workorderState          = { workorderState }
            setWorkorderState       = { setWorkorderState }
          />
          <UploadFiles workorderState = { workorderState } setWorkorderState = { setWorkorderState } maxSizeMb = { maxSizeMb }/>
          <div className="d-flex">
            <div className="ml-auto">
              <div className = "btn btn-outline-default small ml-0 h-fit-content" onClick={() => history.back()}>
                {I18n.t('button.cancel')}
              </div>
              <div className="btn btn-primary small ml-2" onClick = { () => goToStepTwo() }>
                { I18n.t('button.plan') }
              </div>
              <div
                className="btn btn-primary small ml-2"
                onClick  = { () => handleSubmit(formRef.current, false) }
                disabled = { !!isSubmitting }
              >
                { I18n.t('button.save') }
              </div>
            </div>
          </div>
        </form>
      </div>
      { !!isSubmitting &&
        <OverlaySpinner />
      }
    </div>
  )
}
